import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function OpensIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 36} height={height || 36} viewBox="0 0 36 36">
      <g
        data-name="Ellipse 76"
        transform="translate(0 .322) translate(0 -.322)"
        fill="none"
        stroke={color || "#bbb"}
        strokeWidth={1.5}
      >
        <circle cx={18} cy={18} r={18} stroke="none" />
        <circle cx={18} cy={18} r={17.25} />
      </g>
      <text
        data-name="\uF06E"
        transform="translate(0 .322) translate(10 23.678)"
        fill={color || "#bbb"}
        fontSize={15}
        fontFamily="SegoeUI, Segoe UI"
      >
        <tspan x={0} y={0}>
          {"\uF06E"}
        </tspan>
      </text>
    </svg>
  );
}
